
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Beaker } from "lucide-react";

interface RequestedReagentCardProps {
  reagentData: {
    name?: string;
    catalogue_number?: string | null;
    amount?: string | number | null;
    amount_unit?: string | null;
  };
}

const RequestedReagentCard: React.FC<RequestedReagentCardProps> = ({ reagentData }) => {
  return (
    <div>
      <h3 className="text-lg font-medium mb-3 flex items-center">
        <Beaker className="h-5 w-5 mr-2 text-reagent-blue" />
        Requested Reagent
      </h3>
      <Card>
        <CardContent className="pt-6">
          <div className="space-y-3">
            <div>
              <p className="text-sm text-muted-foreground">Name</p>
              <p className="font-medium">{reagentData.name || "Unknown Reagent"}</p>
            </div>
            
            {reagentData.catalogue_number && (
              <div>
                <p className="text-sm text-muted-foreground">Catalog Number</p>
                <p>{reagentData.catalogue_number}</p>
              </div>
            )}
            
            {reagentData.amount && reagentData.amount_unit && (
              <div>
                <p className="text-sm text-muted-foreground">Amount</p>
                <p>{reagentData.amount} {reagentData.amount_unit}</p>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default RequestedReagentCard;
